export default __webpack_public_path__ + "static/media/post-05.b984edba.jpg";